import React from "react";
import SolutionFaq from "./SolutionFaq";

const Solution = () => {
  const solutionData = [
    {
      title: "TRUE IN-DEPTH ASSET MANAGEMENT",
      desc: `Manage all your assets and derive all the details on a multi-pane dashboard`,
      image: "true_card_bg ",
    },
    {
      title: "VULNERABILITY MANAGEMENT",
      desc: `Stay On Top Of All Your Current Vulnerabilities And Get
Detailed Remediation Plans.`,
      image: "vulnerabilty_card_bg",
    },
    {
      title: "RESILIENT RESPONSE PROCESS",
      desc: `Investigate, Respond To Incidents And Contain Any Level Of
Attack With Confidence`,
      image: "resilent_card_bg",
    },
    {
      title: "AI/ML BASED THREAT INTELLIGENCE",
      desc: `Assess Cyber And Physical Threats And Threat Actors To
Mitigate Potential Attacks`,
      image: "based_card_bg",
    },
  ];
  return (
    <>
      <div
        className=" d-md-flex flex_wrap solution_card position-relative d-none"
        id="solutions">
        <h2 className="center_text">
          <span data-aos="zoom-in">
            STAY A STEP AHEAD WITH CYBORYX ICS SOLUTIONS
          </span>
        </h2>

        {solutionData.map((obj, index) => (
          <div
            // data-aos="fade-up"
            // data-aos-delay={`${(index + 1) * 300}`}
            key={index}
            className={`${obj.image} custom_width_solution  ps-lg-5 pe-lg-4 pt-lg-4 p-md-4 px-2 pt-3`}>
            <div className="position-relative heading_line">
              <h2 className="text-white w_50 font-md font-medium mt-lg-3 position-relative z_index_9999 ">
                {obj.title}
              </h2>
              <div className="w_50">
                <p className="text-white card-hover-para ">{obj.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="d-md-none">
        <SolutionFaq />
      </div>
    </>
  );
};

export default Solution;
